var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFigure = function SvgFigure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "figure_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".figure_svg__st0{fill:none}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__st0",
    d: "M29-12.26h11.43v-5.72h-9.87L29-16.42zM29-16.42l1.56-1.56H29z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__st1",
    d: "M22 9.98v12H10v-12h12m0-2H10c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-12a2 2 0 0 0-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "figure_svg__st1",
    d: "M7 13.93c-2.83-.48-5-2.94-5-5.91 0-3.31 2.69-6 6-6 2.97 0 5.43 2.17 5.91 5h2.02c-.49-3.95-3.85-7-7.93-7-4.42 0-8 3.58-8 8 0 4.08 3.05 7.44 7 7.93v-2.02z"
  })));
};
export default SvgFigure;